export const MeetingModule = {
    namespaced: true,
    state: () => ({
        citiesError: 0,
        slotsError: 0
    }),
    mutations: {
        SET_CITIES_ERROR(state, val) {
            state.citiesError = val;
        },
        SET_SLOTS_ERROR(state, val) {
            state.slotsError = val;
        }
    },
};
